// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"fba87700057c74baa8a4","905":"6c46413066d074942263"}[chunkId] + ".chunk.js";
};